// extracted by mini-css-extract-plugin
export var after = "Label-module--after--aec73";
export var before = "Label-module--before--82cfe";
export var themeBlue = "Label-module--themeBlue--d982a";
export var themeOrange = "Label-module--themeOrange--28123";
export var themeYellow = "Label-module--themeYellow--2e332";
export var typeNew = "Label-module--typeNew--04166";
export var typePayment = "Label-module--typePayment--034b8";